import { render, staticRenderFns } from "./BeneficiaryInfoGeo.vue?vue&type=template&id=05a5028c&scoped=true"
import script from "./BeneficiaryInfoGeo.vue?vue&type=script&lang=js"
export * from "./BeneficiaryInfoGeo.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryInfoGeo.vue?vue&type=style&index=0&id=05a5028c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a5028c",
  null
  
)

export default component.exports